// extracted by mini-css-extract-plugin
module.exports = {"metrics":"_3cmXO","grid":"_16h-B","list":"_1yLjV","noMargin":"_21HAv"};